<footer class="bg-gray-200 font-raleway">
  <div class="mx-auto grid grid-cols-3 gap-6 px-5 py-16 lg:container lg:gap-10">
    <div class="col-span-3 lg:col-span-1">
      <div>
        <img
          class="w-32"
          src="assets/images/logo/logo.webp"
          width="198"
          height="85"
          loading="lazy"
          alt="PT Glori Global Makmur" />
      </div>
      <p class="mt-5 text-sm text-slate-700">
        PT. Glori Global Makmur adalah penyedia produk industri yang siap
        menjadi mitra andalan anda. Dengan beragam pilihan produk berkualitas
        dan harga bersaing, kami hadir untuk memenuhi segala kebutuhan proyek
        anda dengan pelayanan yang profesional dan terpercaya.
      </p>
    </div>
    <div class="col-span-3 pt-8 md:col-span-1">
      <h2 class="font-orbitron font-extrabold">Produk Unggulan</h2>
      <ul
        *ngIf="!categoryLoading"
        class="mt-5 grid gap-2 text-sm sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
        <li
          class="cursor-pointer text-slate-700 hover:underline"
          *ngFor="let category of categories">
          <a
            [routerLink]="['/product']"
            [queryParams]="{
              order_by: 'id',
              direction: 'desc',
              category_id: category.id
            }"
            class="capitalize"
            >{{ category.name.toLocaleLowerCase() }}</a
          >
        </li>
      </ul>
      <ul
        *ngIf="categoryLoading"
        class="mt-5 grid gap-2 text-sm sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
        <p-skeleton
          width="8rem"
          height="1rem"
          styleClass="bg-neutral-400"
          *ngFor="let _ of [0, 1, 2, 3]">
        </p-skeleton>
      </ul>
    </div>
    <div class="col-span-3 flex flex-col gap-10 pt-8 md:col-span-1">
      <div>
        <h2 class="font-orbitron font-extrabold">Sosial Media</h2>
        <div class="mt-5 flex flex-col gap-4">
          <div class="flex items-center gap-3">
            <a
              href=""
              aria-label="Facebook"
              class="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white hover:bg-primary-dark">
              <fa-icon class="text-lg" [icon]="faFacebookF"></fa-icon>
            </a>
            <a
              href=""
              aria-label="Instagram"
              class="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white hover:bg-primary-dark">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5" />
              </svg>
            </a>
            <a
              href="mailto:info@gloriglobalmakmur.com"
              aria-label="Email"
              class="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white hover:bg-primary-dark">
              <fa-icon class="text-lg" [icon]="faEnvelope"></fa-icon>
            </a>
          </div>
        </div>
      </div>
      <div>
        <h2 class="font-orbitron font-extrabold">Contact Us</h2>
        <div class="mt-5 flex flex-col gap-4">
          <fc-contact menuAlign="left"></fc-contact>
        </div>
      </div>
    </div>
  </div>
  <div class="border-t border-primary-dark py-2 text-center text-sm">
    © {{ year }} PT. Glori Global Makmur. All right reserved.
  </div>
</footer>
